"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectArea = objectArea;
exports.maximumRadius = maximumRadius;
exports.availableRadius = availableRadius;
exports.enforceSizeLimits = enforceSizeLimits;
// Include some extra occupied area for the hot-air basket and rigging.
function objectArea(object) {
    return Math.PI * object.radius ** 2 * (object.finish === 'hot-air' ? 1.15 : 1);
}
function maximumRadius(width, height, config) {
    const shortSide = Math.max(0, Math.min(width, height));
    return Math.max(0, Math.min(config.maxRadius ?? Infinity, shortSide * (config.maxRadiusScreenRatio ?? config.maxScreenRatio / 3), Math.sqrt(width * height * (config.maxObjectAreaRatio ?? Infinity) / (Math.PI * 1.15))));
}
function availableRadius(object, objects, width, height, config) {
    const used = objects.reduce((area, other) => area + (other === object || other.popped ? 0 : objectArea(other)), 0);
    const remaining = Math.max(0, width * height * (config.maxSceneAreaRatio ?? Infinity) - used);
    return Math.sqrt(remaining / (Math.PI * (object.finish === 'hot-air' ? 1.15 : 1)));
}
/** Resizing must also bound existing objects, not just newly inflated ones. */
function enforceSizeLimits(objects, width, height, config) {
    const max = maximumRadius(width, height, config);
    let total = 0;
    for (const object of objects) {
        if (object.popped)
            continue;
        object.radius = Math.min(object.radius, max);
        total += objectArea(object);
    }
    const budget = width * height * (config.maxSceneAreaRatio ?? Infinity);
    if (total <= budget || total === 0)
        return;
    const scale = Math.sqrt(budget / total);
    for (const object of objects)
        if (!object.popped)
            object.radius *= scale;
}
//# sourceMappingURL=sizeLimits.js.map